import React, { useEffect, useMemo, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import AddResources from "../../containers/pages/projects/AddResources";
import ProjectCreate from "../../containers/pages/projects/ProjectCreate";
import ModalLayout from "../Common/ModalLayout";
import { Tooltip as ReactTooltip } from "react-tooltip";
import NotificationDropdown from "./NotificationDropdown";
import { canViewModule, getModulePermissions, hasAnyModuleView } from "../../utils/moduleAccess";

const Header = ({
  logOut,
  projectHeader,
  projectname,
  tabTitle,
  setStatus,
  params,
  status,
  openMenu,
  setOpenMenu,
  isDeveloper,
  showOverview = true,
  hideNotifications = false,
}) => {
  const [openDrop, setOpenDrop] = useState(false);
  const usersData = useSelector((state) => state.auth.userInfoData);
  const authState = useSelector((state) => state.auth);
  const modulePermissions = useMemo(
    () => getModulePermissions(authState),
    [authState]
  );
  const canViewProject = canViewModule(modulePermissions, "project");
  const canViewBooking = canViewModule(modulePermissions, "booking");
  const canViewPeople = canViewModule(modulePermissions, "people");
  const canViewKpi = canViewModule(modulePermissions, "kpi");
  const canViewCommunications = canViewModule(modulePermissions, "communications");
  const canViewOverview = hasAnyModuleView(modulePermissions, [
    "project",
    "availability",
    "booking",
    "people",
  ]);
  const dispatch = useDispatch();
  const [stepOne, setStepOne] = useState(true);
  const [showMenu, setShowMenu] = useState(false);
  const [open, SetOpenModal] = useState(false);
  const [projectSearch, setProjectSearch] = useState("");
  const [projectSearchData, setProjectSearchData] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const nextStep = (stepComplete) => {
    if (!stepComplete) {
      setStepOne(false);
    } else {
      setStepOne(true);
    }
  };

  const profileDrop = () => {
    setOpenDrop(!openDrop);
  };

  const handleModal = () => {
    if (!open) {
      setStepOne(true);
    }
    SetOpenModal(!open);
  };

  useEffect(() => {
    searchProjects(projectSearch);
  }, [projectSearch]);

  const searchProjects = async (search) => {
    if (search.length < 2) {
      setTimeout(function () {
        if (search.length < 2) {
          setProjectSearchData([]);
        }
      }, 900);

      setProjectSearchData([]);
      return;
    } else {
      const serachData = await dispatch.projects.ProjectTitleSearch({
        search: search,
      });

      setProjectSearchData(serachData.data);
    }
  };

  const pageRedirectAfterSearch = async () => {
    setProjectSearch("");
  };

  return (
    <>
      <div className="w-full border-b border-white/10 h-full md:h-16 flex items-center bg-black shadow-100 py-4 relative z-[100]">
        <div className="container mx-auto">
          <div className="flex items-center w-full">
            {/* logo */}
            <div className="flex items-center justify-start">
              <div className="mr-6 lg:mr-9">
                <img
                  src="/toobler-mark-white-bg.jpg"
                  alt="Toobler"
                  className="h-[40px] w-auto object-contain rounded-md"
                />
              </div>
            </div>

            <div className="flex md:flex-row items-center w-full justify-start">
              {projectHeader ? (
                <div className="items-center w-full justify-start hidden md:flex">
                  <NavLink
                    className="mr-8 text-white font-bold md:flex items-center gap-2 !no-underline hover:text-slate-300 text-decoration-none transition-all duration-200"
                    to="/projects"
                  >
                    <svg
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 0L7.41 1.41L2.83 6L7.41 10.59L6 12L2.86102e-06 6L6 0Z"
                        fill="white"
                      />
                    </svg>

                    <p>{projectname}</p>
                  </NavLink>

                  <header className="px-2">
                    {tabTitle &&
                      tabTitle?.map((item) => (
                        <Link
                          key={item.id}
                          to={`/projects/${params}/${item.status}`}
                        >
                          <button
                            className={`${
                              item?.status === status
                                ? "!text-white"
                                : "border-transparent text-slate-400"
                            } mr-5 font-title text-sm text-white font-normal hover:text-slate-300 text-decoration-none transition-all duration-200`}
                            onClick={() => setStatus(item.status)}
                          >
                            {item.label}
                          </button>
                        </Link>
                      ))}
                  </header>
                </div>
              ) : (
                <div className="hidden main-menu md:flex items-center w-full justify-start gap-6">
                  {showOverview && canViewOverview && (
                    <NavLink
                      activeclassname="is-active"
                      className="py-2 text-sm text-white transition duration-150 ease-out !no-underline hover:text-slate-300 text-decoration-none"
                      to="/"
                    >
                      Overview
                    </NavLink>
                  )}

                  {canViewProject && (
                    <NavLink
                      activeclassname="is-active"
                      className="py-2 text-sm text-white transition duration-150 ease-out !no-underline hover:text-slate-300 text-decoration-none"
                      to="/projects"
                    >
                      Projects
                    </NavLink>
                  )}

                  {canViewBooking && (
                    <NavLink
                      activeclassname="is-active"
                      className="py-2 text-sm text-white transition duration-150 ease-out !no-underline hover:text-slate-300 text-decoration-none"
                      to="/bookings"
                    >
                      Booking
                    </NavLink>
                  )}

                  {canViewPeople && (
                    <NavLink
                      activeclassname="is-active"
                      className="py-2 text-sm text-white transition duration-150 ease-out !no-underline hover:text-slate-300 text-decoration-none"
                      to="/people"
                    >
                      People
                    </NavLink>
                  )}

                  {canViewKpi && (
                    <NavLink
                      activeclassname="is-active"
                      className="py-2 text-sm text-white transition duration-150 ease-out !no-underline hover:text-slate-300 text-decoration-none"
                      to="/kpi"
                    >
                      KPI
                    </NavLink>
                  )}

                  {canViewCommunications && (
                    <NavLink
                      activeclassname="is-active"
                      className="py-2 text-sm text-white transition duration-150 ease-out !no-underline hover:text-slate-300 text-decoration-none"
                      to="/messages"
                    >
                      Messages
                    </NavLink>
                  )}
                </div>
              )}

              <div className="flex items-center w-full justify-end">
                {canViewProject && (
                  <div
                    className={`relative mr-3 ${!isSearchOpen ? "w-1/2" : ""}`}
                  >
                    <div
                      className={`hidden md:absolute top-2/4 -translate-y-2/4 ${
                        isSearchOpen ? "left-[-25px] sm:left-[-25px]" : "right-3"
                      } z-10`}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => setIsSearchOpen(!isSearchOpen)}
                      >
                        <path
                          d="M14.75 15.3965L11.4928 11.8912M11.4928 11.8912C12.0499 11.2916 12.4919 10.5797 12.7934 9.79631C13.095 9.0129 13.2502 8.17324 13.2502 7.32528C13.2502 6.47732 13.095 5.63766 12.7934 4.85425C12.4919 4.07084 12.0499 3.35901 11.4928 2.75941C10.9356 2.15981 10.2741 1.68418 9.54616 1.35968C8.81819 1.03518 8.03795 0.868164 7.25 0.868164C6.46205 0.868164 5.68181 1.03518 4.95384 1.35968C4.22587 1.68418 3.56442 2.15981 3.00725 2.75941C1.882 3.97035 1.24985 5.61275 1.24985 7.32528C1.24985 9.03781 1.882 10.6802 3.00725 11.8912C4.1325 13.1021 5.65866 13.7824 7.25 13.7824C8.84134 13.7824 10.3675 13.1021 11.4928 11.8912Z"
                          stroke="#CBD5E1"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>

                    <div>
                      <input
                        className={`w-full border border-white/10 bg-[#111111] text-white placeholder:text-slate-500 shadow-sm rounded-md p-[6px] text-xs transition-all duration-500 ease-in-out transform focus:outline-none ${
                          isSearchOpen
                            ? "opacity-100 translate-x-0"
                            : "opacity-0 -translate-x-full pointer-events-none"
                        }`}
                        type="text"
                        value={projectSearch}
                        placeholder="Search Project..."
                        onChange={(evt) => {
                          setProjectSearch(evt.target.value);
                        }}
                      />
                    </div>

                    {/* search dropdown */}
                    <div>
                      {projectSearchData && projectSearchData.length ? (
                        <div className="absolute rounded-md bg-[#111111] border border-white/10 transition duration-300 ease-out drop-shadow-md left-0 top-full mt-0.5 right-0 py-2">
                          {projectSearchData &&
                            projectSearchData.length > 0 &&
                            projectSearchData.map((item, ind) => {
                              return (
                                <Link
                                  key={ind}
                                  onClick={() => pageRedirectAfterSearch()}
                                  className="px-4 py-1 text-sm text-white block hover:bg-white/10 transition duration-300 hover:text-slate-300"
                                  to={`/projects/${item.name}/overview`}
                                >
                                  {item.name}
                                </Link>
                              );
                            })}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}

                {/* add project */}
                {!isDeveloper && canViewProject && (
                  <button
                    onClick={() => handleModal()}
                    type="button"
                    className={`hidden md:block text-white text-3xl mr-5 ${
                      isSearchOpen ? "hidden lg:block" : ""
                    }`}
                  >
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 26 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        y="1.14233"
                        width="26"
                        height="26"
                        rx="13"
                        fill="#1E293B"
                      />
                      <path
                        d="M7.60001 14.7044V13.8037H12.4892V8.3999H13.3041V13.8037H18.1932V14.7044H13.3041V20.1082H12.4892V14.7044H7.60001Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                )}

                {/* notifications */}
                {!hideNotifications && (
                  <div className="mr-3 flex items-center">
                    <NotificationDropdown />
                  </div>
                )}

                {/* profile */}
                <div className="relative flex gap-3 items-center justify-center border border-white/10 bg-[#111111] rounded-full cursor-pointer p-1">
                  <div className="flex items-center justify-center gap-1.5 md:gap-3">
                    {/* header initials */}
                    <div
                      onClick={() => profileDrop()}
                      className="text-white text-sm flex items-center justify-center bg-slate-700 w-8 h-8 rounded-full cursor-pointer uppercase"
                    >
                      {usersData?.first_name &&
                        usersData.first_name.substring(0, 1)}

                      {usersData.last_name
                        ? usersData.last_name.substring(0, 1)
                        : usersData.first_name.substring(1, 2)}
                    </div>

                    <svg
                      width="11"
                      height="6"
                      viewBox="0 0 11 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className={`md:hidden transition-all duration-300 ease-out ${
                        openDrop ? "rotate-180" : ""
                      }`}
                      onClick={() => profileDrop()}
                    >
                      <path
                        d="M9.47227 0.128499L5.08894 4.696L0.705618 0.128499C0.627305 0.0467209 0.522172 0.000937432 0.412694 0.000937432C0.303217 0.000937432 0.198083 0.0467209 0.119771 0.128499C0.0818507 0.168215 0.0517252 0.215621 0.0311592 0.267939C0.0105932 0.320257 0 0.376437 0 0.433186C0 0.489936 0.0105932 0.546115 0.0311592 0.598433C0.0517252 0.650751 0.0818507 0.698157 0.119771 0.737873L4.78287 5.59787C4.86476 5.6832 4.97459 5.73095 5.08894 5.73095C5.2033 5.73095 5.31313 5.6832 5.39502 5.59787L10.0581 0.738811C10.0963 0.699065 10.1267 0.651543 10.1474 0.599051C10.1681 0.546559 10.1788 0.490162 10.1788 0.433186C10.1788 0.376211 10.1681 0.319812 10.1474 0.267321C10.1267 0.214829 10.0963 0.167307 10.0581 0.127561C9.97981 0.045783 9.87467 0 9.76519 0C9.65572 0 9.55058 0.0467209 9.47227 0.128499Z"
                        fill="#CBD5E1"
                      />
                    </svg>
                  </div>

                  {/* overlay */}
                  <div
                    onClick={() => profileDrop()}
                    className={`${
                      openDrop
                        ? "fixed inset-0 bg-black opacity-10 z-10"
                        : "hidden"
                    }`}
                  />

                  {/* dropdown */}
                  <div
                    className={`flex-col flex absolute top-[58px] pb-3 md:top-[55px] right-0 w-56 rounded-xl border border-slate-200 bg-white transition duration-300 ease-out drop-shadow-xl z-20 overflow-hidden ${
                      openDrop
                        ? "scale-100 opacity-100"
                        : "scale-95 opacity-0 pointer-events-none"
                    }`}
                  >
                    {/* user details */}
                    <div className="bg-black text-white flex items-center gap-3 px-3 py-3 m-2 rounded-xl">
                      {/* dropdown initials */}
                      <div className="text-white text-sm flex items-center justify-center bg-slate-700 min-w-[38px] h-[38px] rounded-full uppercase">
                        {usersData?.first_name &&
                          usersData.first_name.substring(0, 1)}

                        {usersData.last_name
                          ? usersData.last_name.substring(0, 1)
                          : usersData.first_name.substring(1, 2)}
                      </div>

                      <div className="min-w-0">
                        <p className="text-xs font-semibold text-white truncate m-0 leading-tight">
                          {usersData?.first_name} {usersData?.last_name}
                        </p>

                        <p className="text-[12px] text-slate-400 font-medium truncate mt-1 leading-tight">
                          {usersData?.designation?.name}
                        </p>
                      </div>
                    </div>

                    {/* profile */}
                    <Link
                     className="flex items-center gap-3 px-4 py-3 text-sm text-slate-700 no-underline hover:no-underline hover:text-slate-700 hover:bg-slate-100 transition-all duration-200 border-t border-slate-100"
                      to="/profile"
                    >
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.52917 13.8417C4.30833 13.2458 5.17917 12.776 6.14167 12.4323C7.10417 12.0885 8.1125 11.9167 9.16667 11.9167C10.2208 11.9167 11.2292 12.0885 12.1917 12.4323C13.1542 12.776 14.025 13.2458 14.8042 13.8417C15.3389 13.2153 15.7552 12.5049 16.0531 11.7104C16.351 10.916 16.5 10.0681 16.5 9.16667C16.5 7.13472 15.7858 5.40451 14.3573 3.97604C12.9288 2.54757 11.1986 1.83333 9.16667 1.83333C7.13472 1.83333 5.40451 2.54757 3.97604 3.97604C2.54757 5.40451 1.83333 7.13472 1.83333 9.16667C1.83333 10.0681 1.98229 10.916 2.28021 11.7104C2.57812 12.5049 2.99444 13.2153 3.52917 13.8417ZM9.16667 10.0833C8.26528 10.0833 7.50521 9.77396 6.88646 9.15521C6.26771 8.53646 5.95833 7.77639 5.95833 6.875C5.95833 5.97361 6.26771 5.21354 6.88646 4.59479C7.50521 3.97604 8.26528 3.66667 9.16667 3.66667C10.0681 3.66667 10.8281 3.97604 11.4469 4.59479C12.0656 5.21354 12.375 5.97361 12.375 6.875C12.375 7.77639 12.0656 8.53646 11.4469 9.15521C10.8281 9.77396 10.0681 10.0833 9.16667 10.0833ZM9.16667 18.3333C7.89861 18.3333 6.70694 18.0927 5.59167 17.6115C4.47639 17.1302 3.50625 16.4771 2.68125 15.6521C1.85625 14.8271 1.20312 13.8569 0.721875 12.7417C0.240625 11.6264 0 10.4347 0 9.16667C0 7.89861 0.240625 6.70694 0.721875 5.59167C1.20312 4.47639 1.85625 3.50625 2.68125 2.68125C3.50625 1.85625 4.47639 1.20312 5.59167 0.721875C6.70694 0.240625 7.89861 0 9.16667 0C10.4347 0 11.6264 0.240625 12.7417 0.721875C13.8569 1.20312 14.8271 1.85625 15.6521 2.68125C16.4771 3.50625 17.1302 4.47639 17.6115 5.59167C18.0927 6.70694 18.3333 7.89861 18.3333 9.16667C18.3333 10.4347 18.0927 11.6264 17.6115 12.7417C17.1302 13.8569 16.4771 14.8271 15.6521 15.6521C14.8271 16.4771 13.8569 17.1302 12.7417 17.6115C11.6264 18.0927 10.4347 18.3333 9.16667 18.3333ZM9.16667 16.5C9.97639 16.5 10.7403 16.3816 11.4583 16.1448C12.1764 15.908 12.8333 15.5681 13.4292 15.125C12.8333 14.6819 12.1764 14.342 11.4583 14.1052C10.7403 13.8684 9.97639 13.75 9.16667 13.75C8.35695 13.75 7.59306 13.8684 6.875 14.1052C6.15694 14.342 5.5 14.6819 4.90417 15.125C5.5 15.5681 6.15694 15.908 6.875 16.1448C7.59306 16.3816 8.35695 16.5 9.16667 16.5ZM9.16667 8.25C9.56389 8.25 9.89236 8.12014 10.1521 7.86042C10.4118 7.60069 10.5417 7.27222 10.5417 6.875C10.5417 6.47778 10.4118 6.14931 10.1521 5.88958C9.89236 5.62986 9.56389 5.5 9.16667 5.5C8.76944 5.5 8.44097 5.62986 8.18125 5.88958C7.92153 6.14931 7.79167 6.47778 7.79167 6.875C7.79167 7.27222 7.92153 7.60069 8.18125 7.86042C8.44097 8.12014 8.76944 8.25 9.16667 8.25Z"
                          fill="#6B7280"
                        />
                      </svg>

                      <span className="leading-none">Profile</span>
                    </Link>

                    {/* password */}
                    <Link
                      className="flex items-center gap-3 px-4 py-3 text-sm text-slate-700 no-underline hover:no-underline hover:text-slate-700 hover:bg-slate-100 transition-all duration-200 border-t border-slate-100"
                      to="/change-password"
                    >
                      <svg
                        width="22"
                        height="11"
                        viewBox="0 0 22 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.5 7.33333C4.99583 7.33333 4.56424 7.15382 4.20521 6.79479C3.84618 6.43576 3.66667 6.00417 3.66667 5.5C3.66667 4.99583 3.84618 4.56424 4.20521 4.20521C4.56424 3.84618 4.99583 3.66667 5.5 3.66667C6.00417 3.66667 6.43576 3.84618 6.79479 4.20521C7.15382 4.56424 7.33333 4.99583 7.33333 5.5C7.33333 6.00417 7.15382 6.43576 6.79479 6.79479C6.43576 7.15382 6.00417 7.33333 5.5 7.33333ZM5.5 11C3.97222 11 2.67361 10.4653 1.60417 9.39583C0.534722 8.32639 0 7.02778 0 5.5C0 3.97222 0.534722 2.67361 1.60417 1.60417C2.67361 0.534722 3.97222 0 5.5 0C6.52361 0 7.45174 0.252083 8.28438 0.75625C9.11701 1.26042 9.77778 1.925 10.2667 2.75H18.3333L21.0833 5.5L16.9583 9.625L15.125 8.25L13.2917 9.625L11.3438 8.25H10.2667C9.77778 9.075 9.11701 9.73958 8.28438 10.2437C7.45174 10.7479 6.52361 11 5.5 11ZM5.5 9.16667C6.35556 9.16667 7.10799 8.90694 7.75729 8.3875C8.4066 7.86806 8.83819 7.21111 9.05208 6.41667H11.9167L13.2458 7.35625L15.125 5.95833L16.7521 7.21875L18.4708 5.5L17.5542 4.58333H9.05208C8.83819 3.78889 8.4066 3.13194 7.75729 2.6125C7.10799 2.09306 6.35556 1.83333 5.5 1.83333C4.49167 1.83333 3.62847 2.19236 2.91042 2.91042C2.19236 3.62847 1.83333 4.49167 1.83333 5.5C1.83333 6.50833 2.19236 7.37153 2.91042 8.08958C3.62847 8.80764 4.49167 9.16667 5.5 9.16667Z"
                          fill="#6B7280"
                        />
                      </svg>

                      <span className="leading-none">Change Password</span>
                    </Link>

                    {/* logout */}
                    <Link
                      onClick={logOut}
                      className="flex items-center gap-3 px-4 py-3 text-sm text-rose-500 no-underline hover:no-underline hover:text-rose-500 hover:bg-rose-50 transition-all duration-200 border-t border-slate-100"
                    >
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="shrink-0"
                      >
                        <path
                          d="M1.83333 16.5C1.32917 16.5 0.897569 16.3205 0.538542 15.9615C0.179514 15.6024 0 15.1708 0 14.6667V1.83333C0 1.32917 0.179514 0.897569 0.538542 0.538542C0.897569 0.179514 1.32917 0 1.83333 0H8.25V1.83333H1.83333V1.83333V1.83333V14.6667V14.6667V14.6667H8.25V16.5H1.83333V16.5M11.9167 12.8333L10.6562 11.5042L12.9937 9.16667H5.5V7.33333H12.9937L10.6562 4.99583L11.9167 3.66667L16.5 8.25L11.9167 12.8333V12.8333"
                          fill="#F43F5E"
                        />
                      </svg>

                      <span className="leading-none">Logout</span>
                    </Link>
                  </div>
                </div>
                {/* mobile menu */}
                <div className="ml-2 block md:hidden">
                  {!showMenu ? (
                    <div
                      onClick={() => {
                        projectHeader
                          ? setOpenMenu(!openMenu)
                          : setShowMenu(true);
                      }}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 17H19M5 12H19M5 7H19"
                          stroke="#FFFFFF"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  ) : (
                    <div onClick={() => setShowMenu(false)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="#FFFFFF"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <ModalLayout closeModal={handleModal} open={open}>
            {stepOne ? (
              <ProjectCreate nextStep={nextStep} />
            ) : (
              <AddResources closeModal={handleModal} />
            )}
          </ModalLayout>
        </div>

        {/* tooltips */}
        <ReactTooltip
          id="add-project"
          style={{
            backgroundColor: "#111111",
            color: "white",
            boxShadow: "1px 2px 3px 0px rgba(128, 128, 128, 0.5)",
            zIndex: "30",
          }}
          place="bottom"
          content="Add Project"
        />

        <ReactTooltip
          id="search"
          style={{
            backgroundColor: "#111111",
            color: "white",
            boxShadow: "1px 2px 3px 0px rgba(128, 128, 128, 0.5)",
            zIndex: "30",
          }}
          place="bottom"
        />

        <ReactTooltip
          id="search-close"
          style={{
            backgroundColor: "#111111",
            color: "white",
            boxShadow: "1px 2px 3px 0px rgba(128, 128, 128, 0.5)",
            zIndex: "30",
          }}
          place="bottom"
          content="Close"
        />

        <ReactTooltip
          id="profile"
          style={{
            backgroundColor: "#111111",
            color: "white",
            boxShadow: "1px 2px 3px 0px rgba(128, 128, 128, 0.5)",
            zIndex: "30",
          }}
          place="bottom"
          content="Profile"
        />
      </div>

      {/* mobile menu */}
      <div
        className={`bg-black font-semibold opacity-95 w-full text-white flex h-screen flex-col space-y-4 absolute top-[64px] left-0 pl-5 pt-3 z-50 transition-all duration-500 ease-in-out transform ${
          showMenu
            ? "opacity-100 translate-x-0"
            : "opacity-0 -translate-x-full pointer-events-none"
        }`}
      >
        {showOverview && canViewOverview && (
          <NavLink
            activeclassname="is-active"
            onClick={() => setShowMenu(false)}
            className="py-2 text-white text-sm transition duration-150 ease-out mr-9"
            to="/"
          >
            Overview
          </NavLink>
        )}

        {canViewProject && (
          <NavLink
            activeclassname="is-active"
            onClick={() => setShowMenu(false)}
            className="py-2 text-white text-sm transition duration-150 ease-out mr-9"
            to="/projects"
          >
            Projects
          </NavLink>
        )}

        {canViewBooking && (
          <NavLink
            activeclassname="is-active"
            onClick={() => setShowMenu(false)}
            className="py-2 text-white text-sm transition duration-150 ease-out mr-9"
            to="/bookings"
          >
            Booking
          </NavLink>
        )}

        {canViewPeople && (
          <NavLink
            activeclassname="is-active"
            onClick={() => setShowMenu(false)}
            className="py-2 text-white text-sm transition duration-150 ease-out mr-9"
            to="/people"
          >
            People
          </NavLink>
        )}

        {canViewKpi && (
          <NavLink
            activeclassname="is-active"
            onClick={() => setShowMenu(false)}
            className="py-2 text-white text-sm transition duration-150 ease-out mr-9"
            to="/kpi"
          >
            KPI
          </NavLink>
        )}

        {canViewCommunications && (
          <NavLink
            activeclassname="is-active"
            onClick={() => setShowMenu(false)}
            className="py-2 text-white text-sm transition duration-150 ease-out mr-9"
            to="/messages"
          >
            Messages
          </NavLink>
        )}
      </div>
    </>
  );
};

const mapState = (state) => ({
  userInfo: state.auth.userInfo,
});

const mapDispatch = (dispatch) => ({
  logOut: dispatch.auth.logOut,
});

export default connect(mapState, mapDispatch)(Header);
